import { render } from "./RegisterMain.vue?vue&type=template&id=0cc931d9"
import script from "./RegisterMain.vue?vue&type=script&lang=js"
export * from "./RegisterMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__